import { usePreviewImage } from '@euler/app/components/media/ImageViewerContext';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { Panel } from '@euler/app/tv/components/Panel';
import { DashboardImageView } from '@euler/app/tv/components/pre-inspection/DashboardImageView';
import { FacadeBirdView } from '@euler/app/tv/components/pre-inspection/FacadeBirdView';
import { FacadeInspectionResults } from '@euler/app/tv/components/pre-inspection/FacadeInspectionResults';
import { PreInspectionSummaryView } from '@euler/app/tv/components/pre-inspection/SummaryView';
import { WiredTroubleLightsView } from '@euler/app/tv/components/pre-inspection/TroubleLightsView';
import { TaskScreenContent } from '@euler/app/tv/components/TaskScreenContent';
import { useScreenContentPadding } from '@euler/app/tv/functions/utils';
import { Center } from '@euler/components/Center';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { Suspense, useCallback } from 'react';
import { ActivityIndicator, View } from 'react-native';

export const PreInspectionScreen = wrapNavigatorScreen(() => {
  const { rpx } = useResponsiveContext();
  const { detail, inventoryQuery } = useTaskContext();
  const previewImage = usePreviewImage();
  const [paddingLeft, paddingRight] = useScreenContentPadding();

  const onDashboardImagePress = useCallback(() => {
    if (detail.preInspection.dashboardImgUrl == null) {
      return;
    }
    previewImage({
      imageUrls: [detail.preInspection.dashboardImgUrl],
    });
  }, [detail.preInspection.dashboardImgUrl, previewImage]);

  return (
    <TaskScreenContent targetStatus="preInspection">
      <HStack
        css={`
          flex: 1;
          padding: 0 ${paddingRight}px 0 ${paddingLeft}px;
          padding-bottom: ${rpx(38)}px;
        `}
        alignItems="stretch"
      >
        {/** left side panel */}
        <Panel
          title="检测信息"
          contentContainerStyle={{
            paddingTop: rpx(32),
            flex: 1,
          }}
          css={`
            width: ${rpx(500)}px;
            margin-right: ${rpx(40)}px;
          `}
        >
          <PreInspectionSummaryView
            preInspection={detail.preInspection}
            inventoryQuery={inventoryQuery}
          />

          <FacadeBirdView
            preInspection={detail.preInspection}
            inventoryQuery={inventoryQuery}
            css={`
              margin-top: ${rpx(38)}px;
              margin-left: ${rpx(32)}px;
              margin-right: ${rpx(32)}px;
              margin-bottom: ${rpx(20)}px;
            `}
          />
        </Panel>

        {/** right side panel */}
        <View
          css={`
            flex: 1;
          `}
        >
          {/** right top panel */}
          <Panel
            contentContainerStyle={{
              flexDirection: 'row',
              alignItems: 'stretch',
              flex: 1,
              paddingTop: rpx(20),
            }}
            css={`
              flex: 1;
            `}
          >
            <DashboardImageView
              dashboardImageUrl={detail.preInspection.dashboardImgUrl}
              onPress={onDashboardImagePress}
              css={`
                flex: 1;
              `}
            />

            <Suspense
              fallback={
                <Center
                  css={`
                    flex: 1;
                  `}
                >
                  <ActivityIndicator size="large" />
                </Center>
              }
            >
              <WiredTroubleLightsView
                detail={detail}
                inventoryQuery={inventoryQuery}
                css={`
                  flex: 1;
                  margin-left: ${rpx(60)}px;
                `}
              />
            </Suspense>
          </Panel>

          {/** right bottom panel  */}
          <Panel
            title="车辆外观"
            headerStyle={{
              marginTop: rpx(20),
            }}
            contentContainerStyle={{
              paddingTop: rpx(20),
              flex: 1,
            }}
            css={`
              margin-top: ${rpx(40)}px;
              height: ${rpx(332)}px;
            `}
          >
            <LayoutProviderView
              css={`
                flex: 1;
              `}
            >
              <FacadeInspectionResults
                preInspection={detail.preInspection}
                inventoryQuery={inventoryQuery}
                css={`
                  flex: 1;
                `}
              />
            </LayoutProviderView>
          </Panel>
        </View>
      </HStack>
    </TaskScreenContent>
  );
});
